import axios from "axios";
import { constants } from '../constants/constants';

const getCategories = async (params = {}) => {
  return await axios.get('package-plan-categories', {
    params,
  });
}

const getPackagePlans = async (categoryId, params = {}) => {
  return await axios.get(`package-plan-categories/${categoryId}/package-plans`, {
    params,
  });
}

const getPackagePlan = async (categoryId, packagePlanId) => {
  return await axios.get(`package-plan-categories/${categoryId}/package-plans/${packagePlanId}`);
}

const buyPackagePlan = async (payload) => {
  if (!payload?.gratuity_type) {
    payload.gratuity_type = constants.gratuityTypes.amount;
    payload.gratuity_amount = 0;
  }

  return await axios.post('orders-package-plan', payload);
}

const updatePackagePlanOrder = async (payload, id) => {
  if (payload?.gratuity_type) {
    payload.gratuity_type = 'amount' === payload.gratuity_type?.toString()
      ? constants.gratuityTypes.amount
      : constants.gratuityTypes.percentage
  } else {
    payload.gratuity_type = constants.gratuityTypes.amount;
    payload.gratuity_amount = 0;
  }

  return await axios.put(`orders-package-plan/${id}`, payload);
}

const adjustOrder = async (orderId, payload) => {
  try {
    return await axios.put(`orders-package-plan/${orderId}/adjust`, payload);
  } catch (error) {
    console.error(error);
  }
}

const recalculateOrder = async (orderId, payload) => {
  try {
    return await axios.put(`orders-package-plan/${orderId}/recalculate`, payload);
  } catch (error) {
    console.error(error);
  }
}

export const packagePlansService = {
  getCategories,
  getPackagePlans,
  getPackagePlan,
  buyPackagePlan,
  updatePackagePlanOrder,

  adjustOrder,
  recalculateOrder,
}
